import Checkbox from '@mui/material/Checkbox';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BotaoDuplo from '../../Componentes/BotaoDuplo';
import CampoEdicoes from '../../Componentes/CampoEdicoes';
import CorpoPagina from '../../Componentes/CorpoPagina';
import PesquisaInput from '../../Componentes/PesquisaInput';
import SelectInput from '../../Componentes/SelectInput';
import TopicoTexto from '../../Componentes/TopicoTexto';
import { StoreContexto } from '../../Contexto/Provider';
import { getDados } from '../../Funções/Conexão';
import Init from '../../Funções/Init';
import TextInput from '../../Componentes/TextInput';

export default function Configuracoes() {
  const { idLogin, senhaSalva, controleSalvo } = useContext(StoreContexto);

  const estiloView = (top) => {
    return { width: '90%', marginTop: top };
  };
  const [procrefsalvo, setprocrefsalvo] = useState('');
  const [listaAmbientes, setListaAmbientes] = useState([]);
  const [listaNodes, setListaNodes] = useState([]);
  const [filtroTexto, setFiltroTexto] = useState('');

  const [load, setLoad] = useState(true);

  const [reload, setReload] = useState(false);
  const navega = useNavigate();

  useEffect(() => {
    if (reload == false) {
      setReload(true);
      updateDados();
    }
  }, [reload]);

  const updateDados = () => {
    getDados(Init.url + 'getAmbientes', { controle: controleSalvo, senha: senhaSalva })
      .then((js) => {
        console.log(js);
        let obj = [];
        console.log(JSON.stringify(js.info));
        js.info.map((item) => {
          obj.push(item.local);
        });
        setLoad(false);
        setListaAmbientes(obj);
      })
      .catch(() => {
        setReload(false);
      });
  };

  return (
    <CorpoPagina loading={load}>
      <div className="ContainerGeral">
        <div style={{ width: '90vw' }}>
          <TopicoTexto titulo="Configurações" />

          <h3 className="FonteSelectPadrao" style={{ marginBottom: 24 }}>
            Selecione o filtro abaixo para configuração do Dashboard:
          </h3>

          <div className="MeioLinha">
            <CampoEdicoes titulo="AMBIENTE" height={551} width={424}>
              <div style={estiloView(0)}>
                <SelectInput
                  titulo="Localização"
                  itens={listaAmbientes}
                  clicado={(txt) => {
                    getDados(Init.url + 'getSensoresConfig', {
                      controle: controleSalvo,
                      senha: senhaSalva,
                      ambiente: txt,
                    })
                      .then((js) => {
                        console.log(js);
                        let obj = [];
                        console.log(JSON.stringify(js.info));

                        js.info.map((item) => {
                          obj.push(item);
                        });

                        setListaNodes(obj);
                      })
                      .catch(() => {
                        setReload(false);
                      });
                  }}
                />
              </div>
            </CampoEdicoes>

            <CampoEdicoes titulo="NODES" height={551} width={424} left={32}>
              <div style={estiloView(24)}>
                <PesquisaInput
                  pesquisa="Pesquisar"
                  placeholder="Insira o nome do node"
                  top={32}
                  novoTexto={(txt) => {
                    setFiltroTexto(txt);
                  }}
                />
              </div>

              <div style={{ width: '90%', overflowY: 'scroll', height: 300 }}>
                {listaNodes.map((item) => {
                  if (filtroTexto === '' || item.nome.search(new RegExp(filtroTexto, 'i')) !== -1) {
                    return (
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'row',
                          height: 40,
                          alignItems: 'center',
                          borderBottom: '1px solid #e0e0e0',
                        }}
                      >
                        <Checkbox
                          color="success"
                          id={item.nome}
                          checked={item.mediaSensor == 1 ? true : false}
                          onClick={() => {
                            let l = [...listaNodes];

                            l.map((i) => {
                              if (i.nome === item.nome) {
                                i.mediaSensor = 1 - item.mediaSensor;
                              }
                            });

                            setListaNodes(l);
                          }}
                        />

                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                          <h3
                            style={{
                              fontFamily: 'montserrat',
                              fontSize: 12,
                              fontWeight: 600,
                              margin: 0,
                            }}
                          >
                            {item.nome}
                          </h3>
                          <h4
                            style={{
                              fontFamily: 'montserrat',
                              fontSize: 10,
                              fontWeight: 500,
                              margin: 0,
                            }}
                          >
                            ID:{item.idSensor}
                          </h4>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </CampoEdicoes>
            <CampoEdicoes titulo="Procedimento de Referência" height={551} width={304} left={32}>
              <div style={estiloView(-9)}>
                <TextInput
                  titulo="Procedimento de referência"
                  padrao={procrefsalvo}
                  placeholder="Insira o procedimento de referência"
                  tipo="input"
                  largura="95%"
                  top={15}
                  onUpdate={(txt) => {
                    setprocrefsalvo(txt);
                  }}
                />
              </div>
            </CampoEdicoes>
          </div>

          <BotaoDuplo
            nome="Salvar"
            nomeVolta="Cancelar"
            top={32}
            clicado={async () => {
              console.log(procrefsalvo);

              if (listaNodes !== []) {
                getDados(Init.url + 'RegisterConfig', {
                  controle: controleSalvo,
                  senha: senhaSalva,
                  lista: listaNodes,
                  procref: procrefsalvo,
                })
                  .then((js) => {
                    navega('/DashboardAmbiente');
                  })
                  .catch(() => {
                    setReload(false);
                  });
              }
            }}
          />
        </div>
      </div>
    </CorpoPagina>
  );
}
